// Bottom-right corner grip shown on the selected canvas element. The
// `resize-handle` class lets the drag handler ignore pointer-downs that start
// on the grip so a resize doesn't also start a drag.
export default function ResizeHandle({ onPointerDown }) {
  return (
    <div
      className="resize-handle"
      onPointerDown={onPointerDown}
      style={{
        position: "absolute",
        right: 0,
        bottom: 0,
        width: "12px",
        height: "12px",
        backgroundColor: "#339af0",
        cursor: "nwse-resize",
        zIndex: 20,
      }}
    />
  );
}
